import { frontendURL } from '../../../../helper/URLHelper';
import store from 'dashboard/store';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/security'),
      redirect: to => {
        const account = store.getters.getUserAccounts?.find(
          item => item.id === Number(to.params.accountId)
        );

        return account?.organization_id
          ? {
              name: 'organization_settings_security',
              params: { organizationId: account.organization_id },
            }
          : {
              name: 'legacy_organization_settings_security',
              params: { accountId: to.params.accountId },
            };
      },
    },
  ],
};
